module.exports = __webpack_public_path__ + "5e047d5acdf242e46f3ddb544f7e3c63.jpg";